import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NetworkingMyQuoteDetail } from '../../services/mi-cotizacion/micotizacion.service';
import IMyQuoteDetail from '../../models/mi-cotizacion/IMyQuoteDetail';
import IDescuento from '../../models/mi-cotizacion/IDescuento';
import ICotizacionDetail from '../../models/mi-cotizacion/ICotizacionDetail';
import { Codigo } from '../common/Codigo';
import IMultiProduct from '../../models/mi-cotizacion/IMultiProduct';
import { CampaniaRequest } from '../../models/cotizador/request/model.data.request';
import IResponseImg from '../../models/mi-cotizacion/IImgResponse';
import IRequest from '../../models/mi-cotizacion/IRequest';

@Component({
  selector: 'app-mi-cotizacion',
  templateUrl: './mi-cotizacion.component.html',
  styleUrls: ['./mi-cotizacion.component.css']
})
export class MiCotizacionComponent {

  numeroCotizacion: string = '';
  lineaNombre: string = '';
  planNombre: string = '';
  cuotaInscripcion: string = '';
  cuotaTotal: string = '';
  imgPrograma: string = '';
  listDetallePagoMensual: ICotizacionDetail[] = [];
  codigo_tipo_plan: string = '';

  listImgProgramas: IResponseImg[] = [];

  detalle_descuentos: IDescuento[] = [];

  tipoCotizacion: string = '';

  contratanteBeneficiario: string = '';

  showMultiProduct: boolean = false;

  multiProduct: IMultiProduct[] = [];

  dataCampania: CampaniaRequest = {
    cuenta: 0,
    tipo_solicitud: 0,
    codigo_sucursal: '',
    codigo_tipo_plan: '',
    tarifa: '',
    edad: 0,
    sexo: '',
    modelo_negocio: [],
    descripcionTarifa: ''
  }
  ocultarPlanFamiliar: boolean = true;
  ocultarPlanAsociado: boolean = true;
  dataimagen: any;


  constructor(
    private NetworkingMyQuoteDetail: NetworkingMyQuoteDetail,
    private router: Router,
    private routerParams: ActivatedRoute,
  ) {
    
    this.getDetailquote()
  }

  getImg(img: any){
    this.NetworkingMyQuoteDetail.getImgProduct(img).subscribe((resp)=>{{
      this.imgProductOutputSuccessful(resp)

    }})
  }
  getDetailquote(){
    this.routerParams.params.subscribe( param => {
      var codCotizacion: string = param['numero_cotizacion']
      this.NetworkingMyQuoteDetail.getMyQuoteDetail(codCotizacion).subscribe((response:any)=>{
        this.myQuoteDetailOutputSuccessful(response)
      })
     
     })
    
  }

  async imgProductOutputSuccessful(data: IResponseImg[]) {
    if (this.showMultiProduct) {
      let programa = '';
      this.multiProduct.forEach(p => {
        p.beneficiaryList.forEach(h => {
          programa = h.imgProgram;
          let imgPrograma = data.filter(img => {
            return (img.code === programa)
          })
          h.imgProgram = imgPrograma[0].file
        })
      })
    } else this.imgPrograma = data[0].file;
  }

  imgProductOutputFailure(errorCode: number, message?: string): void {
    const lblMensaje = document.getElementById("lblMensaje");
    if (lblMensaje) {
      lblMensaje.innerText = (message && message !== 'undefined' && message !== 'null' && message !== '') ? message : 'No se pudo obtener las imagenes del productos';
    }
  }
  
  getPlanNombre(typePlan: string) {
    const plan = Codigo.getPlan().filter(data => {
      return (data.codigo === typePlan);
    });
    if (plan[0].descripcion=== "Asociado"){
      this.ocultarPlanFamiliar = false;
    } else if (plan[0].descripcion === "Familiar") {
     
    }
    return plan[0].descripcion;
  }

  getLineaNegocio(typeLine: string) {
    const lineNegocio = Codigo.getLineaNegocio().filter(data => {
      return (data.valor === typeLine);
    });
    return lineNegocio[0].nombre;
  }

  myQuoteDetailOutputSuccessful(resp: IMyQuoteDetail): void {
    this.showMultiProduct = this.valMultiProduct(resp);
    if (this.showMultiProduct) {
      this.listMultiProduct(resp);
    } else {
      this.typeLine(resp);
      this.numeroCotizacion = resp.cotizacion.id;
      this.codigo_tipo_plan = resp.cotizacion.tipo_plan;
      this.planNombre = this.getPlanNombre(resp.cotizacion.tipo_plan);
      this.cuotaInscripcion = resp.cotizacion.cuota_inscripcion;
      this.cuotaTotal = resp.cotizacion.cuota_mensual_total;
      let requestObject: IRequest;
      try {
        requestObject = typeof resp.cotizacion.request === 'string' ? JSON.parse(resp.cotizacion.request) : resp.cotizacion.request;
      } catch (error) {
        console.error('Error parsing request JSON:', error);
        return;
      }
      sessionStorage.setItem("dataContratante", JSON.stringify(requestObject))
      this.dataimagen = requestObject.modelo_negocio.map(mn => mn.programa).flat();
      this.contratanteBeneficiario = (requestObject.Contratante.contratante_usuario) ? 'SI' : 'NO';
      this.listDetallePagoMensual = resp.cotizacionDetalle;
      try {
        this.detalle_descuentos = typeof resp.cotizacion.descuentos === 'string' ? JSON.parse(resp.cotizacion.descuentos) : resp.cotizacion.descuentos;
      } catch (error) {
        console.error('Error parsing descuentos JSON:', error);
        this.detalle_descuentos = []; // o maneja el error como prefieras
      }
    }
  } 

  myQuoteDetailOutputFailure(errorCode: number, message?: string): void {
    const lblMensaje = document.getElementById("lblMensaje");
    if (lblMensaje) {
      lblMensaje.innerText = (message && message !== 'undefined' && message !== 'null' && message !== '') ? message : "No se pudo obtener el detale de la cotización, contacte con administrador";
    }
    this.router.navigateByUrl(`main/miscotizaciones`);
  }
  
  ngOnInit(): void { }

  typeLine(resp: IMyQuoteDetail) {
    let typeLineTemporal: string = '';
    let typeLineSMP: string = '';
    let typeLineSAO: string = '';
    resp.cotizacionDetalle.forEach(data => {
      typeLineTemporal = data.subcuenta.slice(1);
      if (typeLineTemporal === 'SMP') typeLineSMP = typeLineTemporal;
      if (typeLineTemporal === 'SAO') typeLineSAO = typeLineTemporal;
      if (typeLineSMP === 'SMP' && typeLineSAO !== 'SAO') this.lineaNombre = this.getLineaNegocio(typeLineTemporal);
      if (typeLineSMP !== 'SMP' && typeLineSAO === 'SAO') this.lineaNombre = this.getLineaNegocio(typeLineTemporal);
    })
  }

  valMultiProduct(resp: IMyQuoteDetail): boolean {
    let multiProduct: boolean = false;
    if(resp.cotizacionDetalle.length > 1) {
      multiProduct = true;
    }
    
    let typeLineTemporal: string = '';
    let typeLineSMP: string = '';
    let typeLineSAO: string = '';
    resp.cotizacionDetalle.forEach(data => {
      typeLineTemporal = data.subcuenta.slice(1);
      if (typeLineTemporal === 'SMP') typeLineSMP = typeLineTemporal;
      if (typeLineTemporal === 'SAO') typeLineSAO = typeLineTemporal;
      if (typeLineSMP === 'SMP' && typeLineSAO === 'SAO') multiProduct = true;
    })
    return multiProduct;
  }

  listMultiProduct(resp: IMyQuoteDetail) {
    const listBeneficiarySMP: any[] = [];
    const listBeneficiarySAO: any[] = [];
    let nameSMP: string = '';
    let nameSAO: string = '';
    let resultTotalMonthlySMP: number = 0;
    let resultTotalMonthlySAO: number = 0;
    let valueMedIntegral: number = 0;
    let valueSaludOral: number = 0;
    this.numeroCotizacion = resp.cotizacion.id;
    this.detalle_descuentos = resp.cotizacion.descuentos;
    this.dataCampania.codigo_tipo_plan = resp.cotizacion.tipo_plan;
    const plan = this.getPlanNombre(resp.cotizacion.tipo_plan);
    resp.cotizacionDetalle.forEach((data) => {
      const lineBusiness = data.subcuenta.slice(1);
      const info = {
        beneficiaryName: data.beneficiario,
        familyValue: data.valor1,
        associatedValue: data.valor2,
        imgProgram: data.programa
      }
      if (lineBusiness === 'SMP') {
        listBeneficiarySMP.push(info);
        valueMedIntegral = this.sumaPagoTotal(data.valor1, valueMedIntegral);
        resultTotalMonthlySMP = valueMedIntegral;
        nameSMP = lineBusiness;
      } else {
        listBeneficiarySAO.push(info);
        valueSaludOral = this.sumaPagoTotal(data.valor1, valueSaludOral);
        resultTotalMonthlySAO = valueSaludOral;
        nameSAO = lineBusiness;
      }
    });
    if (listBeneficiarySMP.length > 0) {
      this.addMultiProduct(nameSMP, plan, resp.cotizacion.cuota_inscripcion, resultTotalMonthlySMP.toString(), listBeneficiarySMP);
    };
    if (listBeneficiarySAO.length > 0) {
      this.addMultiProduct(nameSAO, plan, resp.cotizacion.cuota_inscripcion, resultTotalMonthlySAO.toString(), listBeneficiarySAO);
    };
  }

  sumaPagoTotal(valor1: number, valor2: number) {
    return (valor1 + valor2);
  }

  addMultiProduct(lineBusiness: string, plan: string, cuota_inscripcion: string, resultTotalMonthly: string, listBeneficiary: any[]) {
    const lineNegocio = this.getLineaNegocio(lineBusiness);
    const info: IMultiProduct = {
      businessName: lineNegocio,
      typeLine: lineNegocio,
      planType: plan,
      registrationFee: cuota_inscripcion,
      totalMonthlyFee: resultTotalMonthly,
      beneficiaryList: listBeneficiary
    }
    this.multiProduct.push(info)
  }

  setValueMoneda(value: any) {
    var numero = "0";
    if (value != null && value != "") {
      value = value.toString().replace(",", "");

      numero = value;
    }
    return new Intl.NumberFormat("es-CO").format(parseInt(numero));
  }

  /** Metodo para setear la moneda */
  valorMoneda(value: string, isListCount: boolean, month: number) {

    let numero: number = 0;
    if (value != null && value != "") {
      value = value.toString().replace(",", "");
      numero = parseInt(value);
    }
    if (isListCount) { numero = numero * month; };

    return new Intl.NumberFormat('es-CO').format(numero);
  }

  goBack() {
    this.router.navigateByUrl(`main/miscotizaciones`);
  }
}
